import React, { useEffect, useState } from "react";
import "../styles/DashboardSlideBarStyles.css";
interface DashboardSlideBarProps {
  options: string[];
  onChange: (value: string) => void;
}

const DashboardSlideBarComponent: React.FC<DashboardSlideBarProps> = ({
  options,
  onChange,
}) => {
  const [selected, setSelected] = useState(options[0] || "");
 //Auto-select valid value when options array updates
  useEffect(() => {
    if (!options.includes(selected)) {
      const firstOption = options[0] || "";
      setSelected(firstOption);
      onChange(firstOption);
    }
  }, [options]);
  const handleSelect = (value: string) => {
    setSelected(value);
    onChange(value);
  };

  return (
    <div className="dashboard-slidebar">
      {options.map((option) => (
        <div
          key={option}
          className={`slidebar-option ${selected === option ? "active" : ""}`}
          onClick={() => handleSelect(option)}
        >
          {option}
        </div>
      ))}
    </div>
  );
};

export default DashboardSlideBarComponent;
